import { render, staticRenderFns } from "./KeyProjects.vue?vue&type=template&id=0a862458&"
import script from "./KeyProjects.vue?vue&type=script&lang=js&"
export * from "./KeyProjects.vue?vue&type=script&lang=js&"
import style0 from "./KeyProjects.vue?vue&type=style&index=0&id=0a862458&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports